import { applicationStore } from "src/store/ApplicationStore";

export function useFooterLogo() {
  return applicationStore.clientBranding?.footerLogoUrl ?? null;
}
